import { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { CustomButton } from '../../../components/CustomButton'
import FuncionariosService from '../../../services/database/FuncionariosService'
import Swal from 'sweetalert2'

export function ModalResetSenhaFunc({ funcId, isOpen, onClose }) {
  const [requestIsLoading, setRequestIsLoading] = useState(false)

  async function handleResetPassword(id) {
    setRequestIsLoading(true)

    try {
      await FuncionariosService.resetPassword(id)

      Swal.fire(
        'Alterado',
        'Sua senha foi alterada para a senha padrão!',
        'success',
      )
    } catch (err) {
      console.log(err)

      Swal.fire('Erro', 'Erro ao resetar senha do funcionário!', 'error')
    } finally {
      setRequestIsLoading(false)
      onClose()
    }
  }

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>Deseja resetar a senha do funcionário?</Modal.Title>
      </Modal.Header>

      <Modal.Footer>
        <CustomButton
          title="Cancelar"
          onClick={onClose}
          color="#ff0000"
          isDisabled={requestIsLoading}
        />
        <CustomButton
          isLoading={requestIsLoading}
          isDisabled={requestIsLoading}
          title="Resetar"
          color=" #ffae00 "
          onClick={() => handleResetPassword(funcId)}
        />
      </Modal.Footer>
    </Modal>
  )
}
